module.exports = __webpack_public_path__ + "img/chain05.52592cc1.png";